import { LOCALES } from '@finder/shared/constants/app.constants';

const getLocalizedTime = (rawTime, locale) => {
        // Set options for stringifying the time to the locale
        enum timeFormatOptions {
            twoDigit = '2-digit',
            numeric = 'numeric'
        }
        const options = {
            hour: timeFormatOptions.twoDigit,
            minute: timeFormatOptions.twoDigit,
            hour12: locale === LOCALES.en_US_normalized
        };

        // Create a date - we just need it to get the time
        const today = new Date().toISOString().slice(0, 10);

        // Now create a date with the raw time so we can format it properly
        const todayTime = new Date(`${today}T${rawTime}`);

        // Stringify the time to the locale formatting
        let time = todayTime.toLocaleTimeString(locale, options);

        // Strip any preceding zero for en-us
        if (locale === LOCALES.en_US_normalized) {
            time = time.replace(/^0/, '');
        }

        return time;
};

export default getLocalizedTime;
